import { FC } from "react";
import { useRoutes } from "react-router-dom";
import { DashboardTheme } from "./components/dashboard";
import { Provider } from 'react-redux';
import { store } from './store';
import { ToastContainer } from 'react-toastify';
import CssBaseline from "@mui/material/CssBaseline";
import SettingsProvider from "./contexts/SettingsContext";
import routesObjectData from "./routes";
import 'react-toastify/dist/ReactToastify.css';

const App: FC = () => {
  const routes = useRoutes(routesObjectData);

  return (
    <Provider store={store}>
      <SettingsProvider>
        <DashboardTheme>
          <CssBaseline />
          {routes}
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </DashboardTheme>
      </SettingsProvider>
    </Provider>
  );
}

export default App;